module.exports = __webpack_public_path__ + "static/img/main_bg02.09b53a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main/main_bg02.jpg
// module id = fkKI
// module chunks = 1